import { render, staticRenderFns } from "./ShapeDropArea.vue?vue&type=template&id=68823863&"
import script from "./ShapeDropArea.vue?vue&type=script&lang=js&"
export * from "./ShapeDropArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports